// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1XpR0","header":"MergedInvoice_header__8gJy3"};